import { ProfilePageContainer } from "@/components/container/profile-page-container";
import MealCreatingProgress from "@/features/go-to/components/meal-creating-progress";
import { useCreateMealPlan } from "@/hooks/features/use-create-meal-plan";
import { useIonRouter } from "@ionic/react";

export default function MyFoodProfilingCreating() {
  const navigation = useIonRouter();
  const { allGenerationStatus } = useCreateMealPlan(() => {
    navigation.push("/profiling/complete", "none");
  });

  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress statues={allGenerationStatus?.statuses} />
    </ProfilePageContainer>
  );
}
